import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {ApiService} from '@drl/core/api/api.service';
import {GetListAPICommand} from '@drl/core/core.module';
import {environment} from '@drl/env/environment';

export class GetPrescriptionAuditLogsCommand<T> extends GetListAPICommand<T> {
  constructor(
    apiService: ApiService,
    adapter: IAdapter<T>,
    prescriptionId: number,
  ) {
    super(
      apiService,
      adapter,
      `${environment.patientApiUrl}/prescriptions/${prescriptionId}/audit-trigger-logs`,
    );
  }
}
